const translations = {
  translation: {
    login: {
      loginTitle: 'Iniciar sesión',
      emailLabel: 'Correo electrónico / Nombre de usuario',
      emailError: 'Ingresa un correo electrónico o nombre de usuario válido',
      emailPlaceholder: 'Ingresa tu correo o nombre de usuario',
      passwordLabel: 'Contraseña',
      passwordError: 'Ingresa una contraseña válida',
      passwordPlaceholder: 'Ingresa tu contraseña',
      credentialsError: 'Credenciales no válidas. Inténtalo de nuevo.',
      tenantInactive:
        'Este sitio no está disponible en este momento. Comunícate con tu administrador si necesitas acceso.',
      //TODO: check
      studentWithNoClasses:
        'No tienes clases asignadas. Comunícate con tu administrador.',
      forgotPasswordButton: '¿Olvidaste tu contraseña?',
      signUpTitle: '¿No tienes una cuenta?',
      signUpButton: 'Registrarse',
      coBrandPlus: '+',
      coBrandProductLogoAlt: 'Logotipo del producto',
      coBrandPartnerLogoAlt: 'Logotipo de la organización',
      lockedTitle: 'Cuenta bloqueada temporalmente',
      lockedDescription:
        'Superaste el máximo de intentos fallidos de inicio de sesión permitidos ({{failed}} de {{max}}). Por tu seguridad, el acceso a la cuenta se bloqueó temporalmente.',
      lockedTryAgain: 'Inténtalo de nuevo en:',
      lockedIllustrationAlt: 'Ilustración de seguridad de la cuenta',
    },
    recoverPassword: {
      title: 'Recuperar contraseña',
      text: 'Ingresa tu correo electrónico o nombre de usuario a continuación y te enviaremos un correo con un enlace para restablecer tu contraseña.',
      identifierLabel: 'Correo electrónico / Nombre de usuario',
      identifierError:
        'Ingresa un correo electrónico o nombre de usuario válido',
      identifierPlaceholder: 'Ingresa tu correo o nombre de usuario',
      sendButton: 'Enviar correo',
    },
    successRecovery: {
      title: '¡Revisa tu bandeja de entrada!',
      text: '¡Ya casi terminas! Encuentra el correo que te enviamos y usa el enlace para restablecer tu contraseña.',
      button: 'Entendido',
    },
    resetPassword: {
      title: 'Ingresa una contraseña nueva',
      passwordLabel: 'Nueva contraseña',
      passwordPlaceholder: 'Ingresa tu nueva contraseña',
      confirmPasswordLabel: 'Confirmar contraseña',
      confirmPasswordPlaceholder: 'Confirma tu nueva contraseña',
      previouslyUsedError:
        'Elige una contraseña que no hayas usado recientemente.',
      policyViolationError: 'Tu contraseña no cumple los requisitos actuales.',
      passwordMatchError: 'Las contraseñas no coinciden.',
      submitButton: 'Restablecer contraseña',
      errorMessage: '¡Uy! Algo salió mal. Inténtalo de nuevo.',
    },
    successResetPassword: {
      title: '¡Listo!',
      text: '¡Tu nueva contraseña ya está lista para usarse!',
      button: 'Continuar',
    },
    expiredResetPassword: {
      title: 'Enlace vencido',
      text: 'Este enlace venció. Solicita uno nuevo.',
      button: 'Recuperar contraseña',
    },
    signup: {
      alreadyHaveAccount: {
        title: '¿Ya tienes una cuenta?',
        button: 'Iniciar sesión',
      },
      setUpLogin: {
        title: 'Crea tu cuenta',
        emailLabel: 'Correo electrónico {{domains}}',
        emailName: 'tu.nombre@{{domain}}',
        emailSeparator: ' o ',
        emailPlaceholder: 'Ingresa tu correo electrónico',
        emailFormatError: 'Ingresa un correo electrónico válido',
        emailDomainError:
          '¡Ups! Usa tu correo que termine en {{domains}} para continuar.',
        passwordLabel: 'Contraseña',
        passwordPlaceholder: 'Crea tu contraseña',
        confirmPasswordLabel: 'Confirmar contraseña',
        confirmPasswordPlaceholder: 'Confirma tu contraseña',
        passwordMatchError: 'Las contraseñas no coinciden.',
        primaryButtonText: 'Continuar',
        termsCheckboxText: 'Leí y acepto los',
        termsAndConditions: 'Términos y condiciones',
        and: 'y la',
        privacyPolicy: 'Política de privacidad',
      },
      teacherAccount: {
        title: 'Bienvenido a',
        subtitle: 'Crea tu cuenta de educador',
        emailLabel: 'Correo electrónico (tu.nombre@school.edu)',
      },
      user: {
        title: 'Antes de hablar de dinero, hablemos de nombres...',
        description:
          'Necesitamos tu nombre para personalizar tu camino hacia el dominio del dinero.',
        firstNameLabel: 'Nombre',
        firstNamePlaceholder: 'Ingresa tu nombre',
        lastNameLabel: 'Apellido',
        lastNamePlaceholder: 'Ingresa tu apellido',
        primaryButtonText: 'Crear cuenta',
        maxLengthError:
          'El nombre y el apellido deben tener menos de 50 caracteres',
      },
      verifyEmail: {
        title: 'Verifica tu correo',
        descriptionPartOne:
          'Enviamos un enlace de verificación a {{email}}. Para terminar de configurar tu cuenta, haz clic en el enlace de ese correo.',
        descriptionPartTwo:
          '¿No lo encuentras? Revisa tu carpeta de spam o correo no deseado, o haz clic abajo para enviarlo de nuevo.',
        primaryButtonText: 'Reenviar correo de verificación',
        primaryButtonTextWithCountDown:
          'Reenviar correo de verificación {{countDown}}',
        successMessage: '¡Correo de verificación enviado!',
      },
      emailVerification: {
        success: {
          title: '¡Tu cuenta se creó correctamente!',
          description:
            '¡Bienvenido! Tu correo se verificó y tu cuenta ya está activa. Ya puedes comenzar tu camino financiero.',
          primaryButtonText: 'Continuar',
        },
        failed: {
          title: 'No se pudo verificar el correo',
          description:
            'No pudimos verificar tu correo porque el enlace no es válido o venció. Solicita un correo de verificación nuevo e inténtalo de nuevo.',
          primaryButtonText: 'Reenviar correo de verificación',
          primaryButtonTextWithCountDown:
            'Reenviar correo de verificación {{countDown}}',
          successMessage: '¡Correo de verificación enviado!',
        },
      },
      successAccountCreated: {
        title: '¡Tu cuenta se creó correctamente!',
        description: '¡Bienvenido! Ya puedes comenzar tu camino financiero.',
        primaryButtonText: 'Continuar',
      },
      errorMessage: 'Algo salió mal. Inténtalo de nuevo',
      claim: {
        title: '¡Hola, {{firstName}} {{lastName}}!',
        subtitle: 'Crea tu cuenta',
        emailLabel: 'Correo electrónico',
        primaryButtonText: 'Crear cuenta',
      },
    },
    invite: {
      title: '¡{{user}} te invitó a una aventura de educación financiera!',
      text: 'Prepárate para aprender los secretos del dinero, evitar desastres de deuda y convertirte en el genio del presupuesto que tu yo del futuro agradecerá.',
      defaultTitle: '¡Únete al equipo de aprendizaje!',
      defaultText:
        '¡Hola! Parece que la invitación se extravió un poco, así que no sabemos quién te envió este enlace. ¡No te preocupes! Igual puedes entrar a nuestro salón de clases en línea y aprovechar todos sus recursos. Ten en cuenta: tu amigo no recibirá beneficios de referido porque no sabemos quién es.',
      button: 'Unirse al Classroom',
      alreadyHaveAccountError: {
        title:
          '¡Hola de nuevo, {{firstName}}! Parece que ya tienes una cuenta con nosotros.',
        subtitle:
          'Agradecemos el referido de tu amigo, pero puedes iniciar sesión con tus credenciales actuales para continuar.',
        button: 'Accede a tu panel aquí',
      },
    },
    sessionExpiredError: {
      title: '¡Uy!',
      subtitle: 'Tu sesión venció.',
      button: 'Volver a iniciar sesión',
    },
    siteUnavailable: {
      title: 'Sitio no disponible',
      subtitle:
        'Esta organización no está abierta en este momento. Vuelve más tarde o comunícate con tu administrador.',
    },
    somethingWentWrongError: {
      title: 'Algo salió mal...',
      subtitle: 'Inténtalo de nuevo.',
      subtitleTeacherSignUp:
        'Encontramos un pequeño inconveniente. Puedes intentarlo ahora o volver más tarde.',
      button: 'Volver',
    },
    passwordRules: {
      length: 'Al menos {{min}} caracteres ({{min}} – {{max}})',
      upperAndLower: 'Al menos 1 letra mayúscula y 1 minúscula',
      numberOrSymbol: 'Al menos 1 número (0 – 9) o símbolo',
      spacesAllowed: 'Se permiten espacios en blanco (frases de contraseña)',
      noSpaces: 'No se permiten espacios',
      loadingRequirements: 'Cargando requisitos de contraseña…',
      loadError:
        'No se pudieron cargar los requisitos de contraseña. Inténtalo de nuevo.',
    },
    hasNoSeatsError: {
      title: '¡Alto! ¡Ya no hay cupo! 🛑',
      subtitle:
        '¡Cero lugares disponibles! Nuestro salón de clases está lleno. Mantente atento e inténtalo pronto: estamos trabajando para dar espacio a más estudiantes.',
    },
    expiredTokenError: {
      title: '¡Ups! Este enlace está vencido o no es válido.',
      subtitle: '¡Es hora de conseguir uno nuevo!',
      button: 'Obtener enlace nuevo',
      successMessage:
        'Enviamos un enlace de activación nuevo a tu correo. Revisa tu bandeja de entrada.',
      errorMessage: 'Algo salió mal. Inténtalo de nuevo.',
    },
    splash: {
      welcome: 'Bienvenido a',
      moneylingo: 'Moneylingo',
      for: 'para',
      poweredBy: 'con tecnología de',
      buttonLabel: 'Hagamos que el dinero se mueva',
    },
  },
};

export default translations;
